// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1wVSv","rootSmall":"AddTileButton_rootSmall__VR9fj"};